import { computed, Ref, unref } from 'vue';
import { skipToken, useQuery } from '@tanstack/vue-query';
import { fetchVersionReport } from './report.endpoints';
import { TAppVersionReportPayload } from '../models/types';

export function useFetchAppVersionReport(payloadRef: Ref<TAppVersionReportPayload | null>) {
  const query = useQuery({
    queryKey: computed(() => {
      const payload = unref(payloadRef);
      return [
        'versionReport',
        payload?.integrationId,
        payload?.branchName,
        payload?.versionId,
        payload?.folderName,
      ];
    }),
    queryFn: computed(() => {
      const payload = unref(payloadRef);
      if (!payload) {
        return skipToken;
      }

      return () => fetchVersionReport(payload);
    }),
  });

  return query;
}
